import React, { Component } from 'react'

import {connect} from "react-redux";
import Card from "@material-ui/core/Card/Card";
import Typography from '@material-ui/core/Typography';

import mqtt from 'mqtt';
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper/Paper";
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import {renderDateTimeText, renderDateTimeToListItem} from "../../../utils/datetimehelp";
import AutoclaveCicloGraficoIndicadores from "../Ciclo/AutoclaveCicloGraficoIndicadores";
import AutoclaveRealTimeInfo from "./AutoclaveRealTimeInfo";
import {getAutoclaves} from "../../../actions/autoclaveActions";
import {withRouter} from "react-router-dom";
import * as queryString from 'query-string';
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton/IconButton";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Help from "../../../common/Help";
import {VolumeUpOutlined} from "@material-ui/icons";
import VolumeOffOutlinedIcon from '@material-ui/icons/VolumeOffOutlined';
import * as alarmMp3 from "./../../../assets/sound/alarm.mp3"




const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const NA = 'N/A'


const styles = theme => ({
    dashboardSection: {
        marginTop: "50px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    chartGrid: {
        textAlign: 'center',
        padding: "10px",
        //  marginBottom: "20px"
    },

    rootEstadoMandril: {
        display: 'flex'
    },
    gridContainerEstadoMandril: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: theme.spacing(3),
    },
    gridEstadoMandril:{
        borderWidth: '1px',

    },
    paperEstadoMandril: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing(1),
    },
    imgRaspa: {
        width: '100%',
        height: '100%'
    }
})



// MQTT broker EMQX (substitui AWS IoT Core) — conecta via WSS atraves do
// bunkerweb (reverse proxy com cert Let's Encrypt em i4-iot.digama.com.br).
// Permite sobrescrever via env vars REACT_APP_MQTT_*.
const MQTT_URL = process.env.REACT_APP_MQTT_URL || 'wss://i4-iot.digama.com.br/mqtt';
const MQTT_USER = process.env.REACT_APP_MQTT_USER || 'i4-devices';
const MQTT_PASS = process.env.REACT_APP_MQTT_PASS || 'Ub3VYMlEACIeF+c8jeRFC4nrYJsE8h0w';


// Modos de monitoramento — 3 estagios que ciclam no botao:
//   Desativado -> Habilitado -> Silencioso -> Desativado ...
// Cada clique envia comando correspondente via MQTT para sgvCore.
const MODE_DISABLED = 'DISABLED';
const MODE_ENABLED = 'ENABLED';
const MODE_SILENT = 'SILENT';

const MODE_LABELS = {
    [MODE_DISABLED]: 'Desativado',
    [MODE_ENABLED]: 'Habilitado',
    [MODE_SILENT]: 'Silencioso',
};

const NEXT_MODE = {
    [MODE_DISABLED]: MODE_ENABLED,
    [MODE_ENABLED]: MODE_SILENT,
    [MODE_SILENT]: MODE_DISABLED,
};


class AutoclaveMonitor extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mqttMode: MODE_DISABLED,
            autoclaves: [],
            emitirSomAlarme: false,
            som: false

        }
        this.habilitarMqtt = this.habilitarMqtt.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.habilitarSom = this.habilitarSom.bind(this);
        this.onMqttMessage = this.onMqttMessage.bind(this);
        this.subscribedTopics = [];
        this.mqttClient = null;
        console.log("AutoclaveMonitor.constructor")
    }


    buildTopicsFromAutoclaves() {
        const list = (this.props.autoclaves && this.props.autoclaves.Autoclaves) || [];
        const topics = [];
        list.forEach(ac => {
            topics.push("sgv/autoclaveStatus/" + ac.id);
            topics.push("sgv/traps/" + ac.id);
        });
        return topics;
    }

    ensureSubscribed() {
        return new Promise((resolve) => {
            if (!this.mqttClient || !this.mqttClient.connected) { resolve(false); return; }
            const topics = this.buildTopicsFromAutoclaves();
            if (topics.length === 0) { resolve(false); return; }
            this.mqttClient.subscribe(topics, { qos: 1 }, (err, granted) => {
                if (err) {
                    console.error("[MQTT] Subscribe error:", err);
                    resolve(false);
                } else {
                    console.log("[MQTT] Subscribe OK -", (granted || []).length, "topics");
                    this.subscribedTopics = topics;
                    resolve(true);
                }
            });
        });
    }

    componentDidMount(){
        console.log("[MQTT] AutoclaveMonitor.componentDidMount")
        this.props.getAutoclaves();

        try {
            console.log("[MQTT] Connecting to", MQTT_URL, "as", MQTT_USER);
            this.mqttClient = mqtt.connect(MQTT_URL, {
                username: MQTT_USER,
                password: MQTT_PASS,
                clean: true,
                reconnectPeriod: 5000,
                connectTimeout: 30000,
            });
            this.mqttClient.on('connect', (ack) => {
                console.log("[MQTT] Connected. sessionPresent=", ack.sessionPresent);
                // Re-subscribe no reconnect se estava em modo ativo
                if (this.state.mqttMode !== MODE_DISABLED) {
                    this.ensureSubscribed();
                }
            });
            this.mqttClient.on('reconnect',   () => console.log("[MQTT] Reconnecting..."));
            this.mqttClient.on('close',       () => console.log("[MQTT] Connection closed"));
            this.mqttClient.on('offline',     () => console.log("[MQTT] Offline"));
            this.mqttClient.on('disconnect',  () => console.log("[MQTT] Disconnect packet received"));
            this.mqttClient.on('error',       (err) => console.error("[MQTT] ERROR:", err.message, err));
            this.mqttClient.on('packetsend',  (pkt) => { if (pkt.cmd === 'publish' || pkt.cmd === 'subscribe') console.log("[MQTT] ->", pkt.cmd, pkt.topic || (pkt.subscriptions || []).length + " topics"); });
            this.mqttClient.on('message', this.onMqttMessage);
        } catch (err) {
            console.error("[MQTT] Falha ao conectar:", err);
        }
    }


    componentWillUnmount(){
        // Cleanup: avisar sgvCore que ninguem esta mais observando
        if (this.state.mqttMode !== MODE_DISABLED) {
            try {
                const aids = (this.props.autoclaves && this.props.autoclaves.Autoclaves)
                    ? this.props.autoclaves.Autoclaves.map(ac => ac.id)
                    : [];
                if (aids.length > 0 && this.mqttClient && this.mqttClient.connected) {
                    this.mqttClient.publish(
                        'sgv/commands',
                        JSON.stringify({ msg: `REALTIME|DISABLE|${aids.toString()}` }),
                        { qos: 1 }
                    );
                }
            } catch (err) {
                console.error("Error publishing DISABLE on unmount", err);
            }
        }
        if (this.mqttClient) {
            try { this.mqttClient.end(true); } catch (_) {}
            this.mqttClient = null;
        }
    }

    onMqttMessage(topic, payloadBytes) {
        try {
            const parsed = JSON.parse(payloadBytes.toString());
            console.log("[MQTT] <- msg:", topic, "aid=", parsed.autoclaveId, "temp=", parsed.EfetivoTemperatura);
            // Compat com shape antigo {value: payload} de aws-amplify
            this.getMqttMessageReceived({ value: parsed });
        } catch (err) {
            console.error("[MQTT] Payload invalido:", err, topic);
        }
    }

    getMqttMessageReceived(data) {
       // console.log('received mqqtt', data );
        const d = data.value;

        const { autoclaveId, Ciclo, ciclo, ...demais  } = d;
        let cic;

        if (!autoclaveId) { return null }
        if (autoclaveId === 0) { return null }

        if (Ciclo) {cic = Ciclo}
        if (ciclo) {cic = ciclo}

        // dados gerais instantaneos
        let narray = this.state.autoclaves;

        let loadChart =  false;

        let pos = narray.findIndex( x => x.autoclaveId === autoclaveId);
        if (pos >= 0) {
            let olddata = narray[pos];

            narray[pos] = { ...olddata, ...demais, autoclaveId: autoclaveId, ciclo: cic }
            this.setState({ autoclaves: narray })

        } else {
            if (this.props.autoclaves.Autoclaves.findIndex( fi => fi.id === autoclaveId) >= 0 ) {
                narray.push({...demais, autoclaveId: autoclaveId, ciclo: ciclo})
                this.setState({autoclaves: narray})
            }
        }


        let esom = false;
        this.state.autoclaves.map( (aRT) => {
            if ( aRT.AlarmeSemComunicacao || aRT.AlarmeEmergencia || aRT.AlarmePT100 || aRT.AlarmeFaltaEnergia ||
                aRT.AlarmeVentilador || aRT.AlarmeVentilador ||aRT.AlarmeSupervisaoPressaoSacoDeAr ||
                aRT.AlarmeSupervisaoPressaoEnvelope||  aRT.AlarmeSupervisaoAquecimento || aRT.AlarmeTemperaturaBaixa ||
                aRT.AlarmeTemperaturaAlta || aRT.AlarmePressaoAltaSacoDeAr || aRT.AlarmePressaoAltaEnvelope || aRT.AlarmePressaoBaixa ||
                aRT.AlarmePressaoAlta || aRT.AlarmePressaoBaixaSacoDeAr||  aRT.AlarmePressaoBaixaEnvelope || aRT.AlarmeFalhaSensorAutoclave ||
                aRT.AlarmeFalhaSensorSacoDeAr||  aRT.AlarmeFalhaSensorEnvelope||  aRT.AlarmeFalhaAcionamentoVentilador||
                aRT.AlarmeTripAquecimento  || aRT.AlarmeBateriaCLP || aRT.AlarmeDescargaSacoDeAr || aRT.AlarmeDescargaEnvelope ||
                aRT.AlarmePortaAutoclaveAberta || aRT.AlarmePressostato  || aRT.AlarmeTermostato || aRT.AlarmeFalhaRetornoContactoraAquecimento) {
                esom = true;
            }
        });

        if (esom !== this.state.som) {
            this.setState({som : esom });
        }



    }



    async habilitarMqtt(){
        if (!this.mqttClient) {
            console.error("[MQTT] client nao inicializado");
            return;
        }

        const list = (this.props.autoclaves && this.props.autoclaves.Autoclaves) || [];
        const aids = list.map(ac => ac.id);

        const currentMode = this.state.mqttMode;
        const nextMode = NEXT_MODE[currentMode];
        const goingToDisabled = nextMode === MODE_DISABLED;

        console.log(`[MQTT] mode transition: ${currentMode} -> ${nextMode} (autoclaves=${aids.length})`);

        if (goingToDisabled) {
            // Unsubscribe tudo ao voltar pra Desativado
            if (this.subscribedTopics.length > 0) {
                this.mqttClient.unsubscribe(this.subscribedTopics);
                console.log("[MQTT] Unsubscribed", this.subscribedTopics.length, "topics");
                this.subscribedTopics = [];
            }
        } else {
            // CRITICO: aguarda SUBACK antes de publicar o comando.
            // Se publicar antes do subscribe estar ativo, o SendAllData
            // imediato que o sgvCore dispara em SetMonitorMode chega
            // antes da nossa assinatura e a mensagem se perde.
            await this.ensureSubscribed();
        }

        // Publicar comando apos subscribe confirmado
        this.mqttClient.publish(
            'sgv/commands',
            JSON.stringify({ msg: `REALTIME|${nextMode}|${aids.toString()}` }),
            { qos: 1 },
            (err) => {
                if (err) console.error("[MQTT] Publish error:", err);
                else console.log("[MQTT] Publish OK - REALTIME|" + nextMode);
            }
        );

        this.setState({ mqttMode: nextMode });

        // Reforco: envia KEEPALIVE em salvas se for pra modo ativo.
        // O handler do sgvCore zera DTUltimoMqttDadosGerais de todas as
        // autoclaves, forcando SendAllData imediato. Multiplos KEEPALIVEs
        // garantem recebimento mesmo em caso de perda/race de subscribe.
        if (!goingToDisabled) {
            this.sendKeepalivePulses();
        }
    }

    sendKeepalivePulses() {
        const delays = [300, 2500, 8000]; // 3 pulsos: 0.3s, 2.5s, 8s apos habilitar
        delays.forEach((ms) => {
            setTimeout(() => {
                if (this.mqttClient && this.mqttClient.connected) {
                    this.mqttClient.publish(
                        'sgv/commands',
                        JSON.stringify({ msg: 'KEEPALIVE' }),
                        { qos: 1 },
                        (err) => {
                            if (err) console.error("[MQTT] KEEPALIVE publish err:", err);
                            else console.log("[MQTT] KEEPALIVE sent (+", ms, "ms)");
                        }
                    );
                }
            }, ms);
        });
    }


    habilitarSom(){
        this.setState({emitirSomAlarme : !this.state.emitirSomAlarme})
    }




    renderContent() {
        const {classes} = this.props;
        if (this.state.mqttMode === MODE_DISABLED) {
            return null
        }



        const mais = queryString.parse(this.props.location.search).mais ? true : false




        return <React.Fragment>
            {/*<Grid item xs={12} lg={12} className={classes.chartGrid}>*/}
                    {/*<MaterialTable*/}
                        {/*icons={tableIcons}*/}
                        {/*title=""*/}
                        {/*columns={this.getColumns()}*/}
                        {/*data={this.state.autoclaves}*/}
                        {/*options={{*/}
                            {/*filtering: true,*/}
                            {/*pageSize: 5,*/}
                            {/*pageSizeOptions: [3,5,10,15],*/}
                            {/*addRowPosition: 'first'*/}
                        {/*}}*/}
                    {/*/>*/}






            { this.state.emitirSomAlarme && this.state.som &&
                    <div>
                        <audio ref="audio_tag" src={alarmMp3} loop autoPlay/>
                    </div>
            }

            <Grid container item  styles={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}} lg={12} xl={12}>
                {
                    this.state.autoclaves
                        .sort(function(a, b) {
                            if (a.autoclaveId < b.autoclaveId) { return -1; }
                            if (a.autoclaveId > b.autoclaveId) { return 1; }
                            return 0;
                        })

                        .map(a => {


                        return <Grid item key={a.autoclaveId} xs={12} sm={12} md={6} lg={4} xl={3} className={classes.chartGrid} styles={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                <AutoclaveRealTimeInfo
                                    key={a.autoclaveId}
                                    autoclaveRealTime={a}
                                    mais={mais}

                                />
                        </Grid>
                    })
                }
            </Grid>


        </React.Fragment>

    }

    render() {
        const { classes } = this.props;

        console.log("state: ",this.props.all);

        console.log("This.state.som", this.state.som);

        return (
            <React.Fragment>
                <Grid container direction="row" >
                    <Grid item  xs={12} lg={12} className={classes.chartGrid}>
                        <Grid item xs={12} lg={12} className={classes.chartGrid}>
                            <Grid container>
                                <Grid item  xs={9} sm={9} lg={9} xl={9}>
                                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                                        AUTOCLAVES - TEMPO REAL
                                        <span style={{
                                            marginLeft: 16,
                                            fontSize: '0.55em',
                                            fontWeight: 400,
                                            padding: '4px 12px',
                                            borderRadius: 12,
                                            verticalAlign: 'middle',
                                            color: '#fff',
                                            backgroundColor:
                                                this.state.mqttMode === MODE_ENABLED ? '#2e7d32'
                                              : this.state.mqttMode === MODE_SILENT  ? '#757575'
                                              : '#c62828',
                                        }}>
                                            {MODE_LABELS[this.state.mqttMode]}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <Button
                                        variant="contained"
                                        color={this.state.mqttMode === MODE_ENABLED ? 'primary'
                                             : this.state.mqttMode === MODE_SILENT  ? 'default'
                                             : 'secondary'}
                                        onClick={this.habilitarMqtt}
                                        title={`Clique para mudar para ${MODE_LABELS[NEXT_MODE[this.state.mqttMode]]}`}
                                    >
                                        {MODE_LABELS[this.state.mqttMode]}
                                    </Button>

                                        <IconButton color="secondary"  onClick={this.habilitarSom} >
                                            { this.state.emitirSomAlarme  && <VolumeUpOutlined fontSize="large" />}
                                            { !this.state.emitirSomAlarme  && <VolumeOffOutlinedIcon fontSize="large" />}
                                        </IconButton>


                                </Grid>
                            </Grid>
                            <Typography variant="caption" component="div" style={{
                                textAlign: 'center',
                                color: '#666',
                                marginTop: -16,
                                marginBottom: 8,
                                fontSize: '0.80rem',
                            }}>
                                <b style={{color:'#2e7d32'}}>Habilitado</b>: atualizacoes frequentes (a cada ~30s) — acompanhamento em tempo real.
                                {' · '}
                                <b style={{color:'#757575'}}>Silencioso</b>: atualizacoes espacadas (a cada ~60s), mas alarmes chegam imediatamente.
                                {' · '}
                                <b style={{color:'#c62828'}}>Desativado</b>: sem atualizacoes continuas (~180s), ideal quando ninguem esta observando.
                            </Typography>
                        </Grid>

                        {this.renderContent()}

                    </Grid>
                </Grid>
            </React.Fragment>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        all: state,
        autoclaves: state.autoclaves,
        pneus: state.tires
    }
}

export default withRouter(connect(mapStateToProps, { getAutoclaves })(withStyles(styles, {withTheme: true})(AutoclaveMonitor)));
